import { render, staticRenderFns } from "./section-alianzas.vue?vue&type=template&id=02f275a1&scoped=true"
import script from "./section-alianzas.vue?vue&type=script&lang=js"
export * from "./section-alianzas.vue?vue&type=script&lang=js"
import style0 from "./section-alianzas.vue?vue&type=style&index=0&id=02f275a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f275a1",
  null
  
)

export default component.exports